import type { ColumnDef } from "@tanstack/react-table";
import { ReviewBadge } from "@/accounts-payable/common";
import type { ApInvoice } from "@/accounts-payable/types";

export const reviewCol: ColumnDef<ApInvoice> = {
  accessorKey: "review_state",
  header: "Review",
  meta: { size: "130px" },
  cell: ({ row }) => <ReviewBadge document={row.original} />,
};
